module.exports = __webpack_public_path__ + "src/assets/textures/env/tractor/coolant_tank_512_bake.png";